
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Comment créer un cahier des charges d'un site internet ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez les étapes clés pour rédiger un cahier des charges efficace pour votre site internet, incluant objectifs, fonctionnalités et design",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Comment créer un cahier des charges d'un site internet ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez les étapes clés pour rédiger un cahier des charges efficace pour votre site internet, incluant objectifs, fonctionnalités et design",
        },
        // {
        //   hid: "og:image",
        //   property: "og:image",
        //   content: require("~/assets/img/og/og-facebook-apropos.jpg"),
        // },
      ],
    };
  },
};
